/**
 * Services — Concentration — frontend behaviour.
 *
 * Sequential blur-in (header → cards), each card's green bar fills left→right
 * on entrance and re-fills on hover. Mirrors the Our Roots motion language.
 * Skipped under prefers-reduced-motion. Loaded only on pages with this block.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-deliverables]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const headEls = Array.from(section.querySelectorAll('[data-deliverables-anim]'));
		const cards = Array.from(section.querySelectorAll('[data-deliverables-card]'));
		const bars = Array.from(section.querySelectorAll('[data-deliverables-bar]'));
		if (!headEls.length && !cards.length) return;

		if (reduced) {
			[...headEls, ...cards].forEach((el) => {
				el.style.opacity = '1';
				el.style.filter = 'none';
				el.style.transform = 'none';
			});
			return;
		}

		gsap.set(headEls, { opacity: 0, y: 20, filter: 'blur(10px)' });
		gsap.set(cards, { opacity: 0, y: 28, filter: 'blur(12px)' });
		gsap.set(bars, { scaleX: 0 });

		const play = () => {
			const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

			headEls.forEach((el, i) => {
				tl.to(el, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7 }, 0.1 + i * 0.12);
			});

			const cardsStart = Math.max(0.25, headEls.length * 0.12);
			// clearProps:transform so GSAP's leftover inline transform doesn't
			// override the CSS :hover lift.
			tl.to(cards, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, stagger: 0.1, clearProps: 'transform' }, cardsStart);
			tl.to(bars, { scaleX: 1, duration: 0.6, ease: 'power2.out', stagger: 0.1 }, cardsStart + 0.2);
		};

		// Re-fill a card's bar on hover (same left→right sweep as entrance).
		cards.forEach((card) => {
			const bar = card.querySelector('[data-deliverables-bar]');
			if (!bar) return;
			card.addEventListener('mouseenter', () => {
				gsap.fromTo(
					bar,
					{ scaleX: 0 },
					{ scaleX: 1, duration: 0.5, ease: 'power2.out', overwrite: true }
				);
			});
		});

		const io = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					io.unobserve(entry.target);
					play();
				});
			},
			{ rootMargin: '0px 0px -15% 0px', threshold: 0.1 }
		);
		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
